import { ynType } from "app/model/common/code";

export const logCd = {
  RP: "RP",
  CP: "CP",
  EM: "EM",
  OM: "OM",
  IO: "IO",
} as const;

export type ActvLogCd = keyof typeof logCd;

export interface ActvLogModel {
  logId: string;
  logYn: ynType;
  logMsgCtt: string;
  actvLogCd: ActvLogCd;
  regrId: string;
  regDate: Date;
}

export interface ActvLogSaveModel {
  actvLogCd: ActvLogCd;
  logMsgCtt: string;
  logId?: string;
  // userId?: string;
}

export interface ActvLogDateModel {
  fromDt: string;
  toDt: string;
}

export const logMsg = {
  /* RE100 플래너 */
  RP: {
    re100: {
      goal: {
        C: 'RE100 연간 목표가 등록되었습니다.' as const,
        U: 'RE100 연간 목표가 변경되었습니다.' as const,
      } as const,
      scnro: {
        C: 'RE100 시나리오가 등록되었습니다.' as const,
        U: 'RE100 시나리오가 변경되었습니다.' as const,
      } as const,
    } as const,
    fufl: {
      self: {
        C: '자가발전 이행수단 실적이 등록되었습니다.' as const,
        U: '자가발전 이행수단 실적이 변경되었습니다.' as const,
        D: '자가발전 이행수단 실적이 삭제되었습니다.' as const,
      } as const,
      ppa: {
        C: 'PPA 이행수단 실적이 등록되었습니다.' as const,
        U: 'PPA 이행수단 실적이 변경되었습니다.' as const,
        D: 'PPA 이행수단 실적이 삭제되었습니다.' as const,
      } as const,
      rec: {
        C: 'REC 이행수단 실적이 등록되었습니다.' as const,
        U: 'REC 이행수단 실적이 변경되었습니다.' as const,
        D: 'REC 이행수단 실적이 삭제되었습니다.' as const,
      } as const,
      green: {
        C: '녹색프리미엄 이행수단 실적이 등록되었습니다.' as const,
        U: '녹색프리미엄 이행수단 실적이 변경되었습니다.' as const,
        D: '녹색프리미엄 이행수단 실적이 삭제되었습니다.' as const,
      } as const,
    } as const,
    use: {
      self: '자가발전 재생에너지 사용 확인서의 실적이 전환되었습니다.' as const,
      ppaDirect: '직접 PPA 재생에너지 사용 확인서의 실적이 전환되었습니다.' as const,
      ppaThird: '제3자 PPA 재생에너지 사용 확인서의 실적이 전환되었습니다.' as const,
      rec: 'REC 재생에너지 사용 확인서의 실적이 전환되었습니다.' as const,
      green: '녹색프리미엄 재생에너지 사용 확인서의 실적이 전환되었습니다.' as const,
    } as const,
  } as const,
  /* 탄소 플래너 */
  CP: {
    setting: {
      C: '경계 설정이 등록되었습니다.' as const,
      U: '경계 설정이 변경되었습니다.' as const,
    } as const,
    actv: {
      C: '활동데이터가 등록되었습니다.' as const,
      U: '활동데이터가 변경되었습니다.' as const,
      D: '활동데이터가 삭제되었습니다.' as const,
    } as const,
    crtr: {
      C: '기준연도, 목표강도가 등록되었습니다.' as const,
      U: '기준연도, 목표강도가 변경되었습니다.' as const,
    } as const,
    goal: {
      C: '목표강도가 등록되었습니다.' as const,
      U: '목표강도가 변경되었습니다.' as const,
    } as const,
    emcrd: {
      C: '배출권이 등록되었습니다.' as const,
      U: '배출권이 변경되었습니다.' as const,
      D: '배출권이 삭제되었습니다.' as const,
    } as const,
    biz: {
      C: '사업계획서가 등록되었습니다.' as const,
      U: '사업계획서가 변경되었습니다.' as const,
      D: '사업계획서가 삭제되었습니다.' as const,
    } as const,
    moni: {
      C: '모니터링 보고서가 등록되었습니다.' as const,
      U: '모니터링 보고서가 변경되었습니다.' as const,
      D: '모니터링 보고서가 삭제되었습니다.' as const,
    } as const,
    evdn: {
      C: '인증자료가 등록되었습니다.' as const,
      U: '인증자료가 변경되었습니다.' as const,
      D: '인증자료가 삭제되었습니다.' as const,
    } as const,
    actvDoc: {
      C: '활동자료가 등록되었습니다.' as const,
      U: '활동자료가 변경되었습니다.' as const,
      D: '활동자료가 삭제되었습니다.' as const,
    } as const,
  } as const,
  /* 에너지마켓 */
  EM: {
    ppa: {
      apl: 'PPA 매칭이 요청되었습니다.' as const,
      cntr: 'PPA 거래에 대한 계약서가 작성되었습니다.' as const,
      instt: 'PPA 계약에 대한 기관등록이 완료되었습니다.' as const,
      complete: 'PPA 계약이 완료되었습니다.' as const,
    } as const,
    rec: {
      trd: {
        C: 'REC 거래가 등록되었습니다.' as const,
        U: 'REC 거래가 수정되었습니다.' as const,
        D: 'REC 거래가 삭제되었습니다.' as const,
      } as const,
      apl: 'REC 거래에 대한 요청이 등록되었습니다.' as const,
      cntr: 'REC 거래에 대한 계약서가 작성되었습니다.' as const,
      otran: 'REC 계약에 대한 이전신청이 완료되었습니다.' as const,
      complete: 'REC 계약이 완료되었습니다.' as const,
    } as const,
    ems: {
      trd: {
        C: '배출권 거래가 등록되었습니다.' as const,
        U: '배출권 거래가 수정되었습니다.' as const,
        D: '배출권 거래가 삭제되었습니다.' as const,
      } as const,
      apl: '배출권 거래에 대한 요청이 등록되었습니다.' as const,
      cntr: '배출권 거래에 대한 계약서가 작성되었습니다.' as const,
      otran: '배출권 계약에 대한 이전신청이 완료되었습니다.' as const,
      complete: '배출권 계약이 완료되었습니다.' as const,
    } as const,
    bill: {
      pbls: '청구서가 발행되었습니다.' as const,
      setl: '거래 대금 납부 정보가 생성되었습니다.' as const,
    } as const,
    rpdc: {
      money: {
        C: '정산조정 신청이 등록되었습니다.' as const,
        U: '정산조정 신청이 수정되었습니다.' as const,
        D: '정산조정 신청이 삭제되었습니다.' as const,
      } as const,
      trd: {
        C: '부정거래 신고가 등록되었습니다.' as const,
        U: '부정거래 신고가 수정되었습니다.' as const,
        D: '부정거래 신고가 삭제되었습니다.' as const,
      }
    } as const,
  } as const,
  /* 운영 관리 */
  OM: {
    daily: {
      C: '일상점검이 등록되었습니다.' as const,
      U: '일상점검이 수정되었습니다.' as const,
      D: '일상점검이 삭제되었습니다.' as const,
    } as const,
    weekly: {
      C: '주간점검이 등록되었습니다.' as const,
      U: '주간점검이 수정되었습니다.' as const,
      D: '주간점검이 삭제되었습니다.' as const,
    } as const,
    spcl: {
      C: '특별점검이 등록되었습니다.' as const,
      U: '특별점검이 수정되었습니다.' as const,
      D: '특별점검이 삭제되었습니다.' as const,
    } as const,
    report: '보고서를 조회했습니다.' as const,
  } as const,
  /* 정보 공개 */
  IO: {
    api: 'API가 신청되었습니다.' as const,
    qna: {
      C: 'Q&A가 등록되었습니다.' as const,
      U: 'Q&A가 수정되었습니다.' as const,
      D: 'Q&A가 삭제되었습니다.' as const,
    },
    apiR: {
      C: 'API가 등록되었습니다.' as const,
      U: 'API가 수정되었습니다.' as const,
      D: 'API가 삭제되었습니다.' as const,
    },
  } as const,
} as const;